module.exports = __webpack_public_path__ + "hand-rounded.svg?ffe8e5ee28274a2040ca79d2d4b7a578";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/hand-rounded.svg
// module id = 194
// module chunks = 0